import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { computed, signal } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { SKIP_LOADING } from './http-context.tokens';

const pending = signal(0);
export const isLoading = computed(() => pending() > 0);
export const loadingInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (req.context.get(SKIP_LOADING)) return next(req);
  pending.update((value) => value + 1);
  return next(req).pipe(finalize(() => pending.update((value) => Math.max(0, value - 1))));
};
